import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Calendar, Coffee } from 'lucide-react';
export function BonusSection() {
  return <section className="py-20 md:py-28 px-4 bg-primary text-warm relative overflow-hidden" data-id="element-33">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-cta/20 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/2" data-id="element-34"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-highlight/10 rounded-full blur-[100px] translate-y-1/2 -translate-x-1/2" data-id="element-35"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-37">
          <div className="inline-flex items-center justify-center p-3 bg-white/10 rounded-full mb-6" data-id="element-38">
            <Gift className="w-8 h-8 text-highlight" data-id="element-39" />
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-warm mb-4" data-id="element-40">
            Además, hoy recibís totalmente{' '}
            <span className="text-highlight" data-id="element-41">GRATIS</span>
          </h2>
          <p className="text-lg text-beige/80 max-w-2xl mx-auto" data-id="element-42">
            Estos bonos están pensados para ayudarte a sostener el proceso y
            potenciar resultados.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-43">
          {/* Bonus 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white/5 border border-white/10 rounded-2xl p-8 relative overflow-hidden group hover:bg-white/10 transition-colors" data-id="element-44">
            <div className="absolute top-4 right-4 bg-highlight text-primary text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-45">
              Hoy Gratis
            </div>

            <Calendar className="w-12 h-12 text-highlight mb-6" data-id="element-46" />
            <h3 className="text-2xl font-bold text-warm mb-3 font-serif" data-id="element-47">
              BONUS 1 <br data-id="element-48" />
              <span className="text-highlight" data-id="element-49">Planner Glow Up 30 días</span>
            </h3>
            <p className="text-beige/80 leading-relaxed" data-id="element-50">
              Una herramienta práctica para hacer seguimiento de tus hábitos y
              mantener la constancia día a día sin perder el foco.
            </p>
          </motion.div>

          {/* Bonus 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="bg-white/5 border border-white/10 rounded-2xl p-8 relative overflow-hidden group hover:bg-white/10 transition-colors" data-id="element-51">
            <div className="absolute top-4 right-4 bg-highlight text-primary text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-52">
              Hoy Gratis
            </div>

            <Coffee className="w-12 h-12 text-highlight mb-6" data-id="element-53" />
            <h3 className="text-2xl font-bold text-warm mb-3 font-serif" data-id="element-54">
              BONUS 2 <br data-id="element-55" />
              <span className="text-highlight" data-id="element-56">Glow Drinks</span>
            </h3>
            <p className="text-beige/80 leading-relaxed" data-id="element-57">
              Recetas simples para mejorar tu energía, tu bienestar y acompañar
              tu cambio físico desde adentro hacia afuera.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}